import React from 'react';
import DateRangeGit from '@shared/components/CustomDatePicker';
import FlightsSearchLayout from '../FlightsSearchLayout';

const RoundTrip = ({
  airSectionRow,
  setAirSectionRow,
  handleClick,
  showPassengers,
  handleClose,
  flightClass,
  setFlightClass,
  executeSearch,
  hasErrorMessage,
  searchPax,
  setSearchPax,
}) => {
  return (
    <FlightsSearchLayout
      layoutType="roundtrip"
      components={{
        Left: { md: 6 },
        Middle: {
          component: (
            <DateRangeGit
              checkInParam={airSectionRow[0]?.date}
              checkOutParam={airSectionRow[1]?.date}
              placeholders={{ startDate: 'Salida', endDate: 'Regreso' }}
              dateInfo={({ check_in, check_out }) => {
                const newAirSection = [...airSectionRow];
                if (newAirSection[0]) newAirSection[0].date = check_in;
                if (newAirSection[1]) newAirSection[1].date = check_out;
                setAirSectionRow(newAirSection);
              }}
            />
          ),
          md: 4,
        },
      }}
      {...{
        airSectionRow,
        setAirSectionRow,
        handleClick,
        showPassengers,
        handleClose,
        setFlightClass,
        flightClass,
        executeSearch,
        hasErrorMessage,
        searchPax,
        setSearchPax,
      }}
    />
  );
};

export default RoundTrip;
